module.exports = __webpack_public_path__ + "static/media/tab-front.061d30d9.png";